"use client";

import { useTranslations } from "next-intl";

const brandLogos = [
  {
    key: "tiferetEcosystem",
    gradient: "from-amber-500 via-orange-400 to-yellow-300",
    halo: "bg-amber-300/25",
    underlineGradient:
      "linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,193,94,0.9) 45%, rgba(255,193,94,0.9) 55%, rgba(255,255,255,0) 100%)",
  },
  {
    key: "akivaYosefInitiatives",
    gradient: "from-rose-500 via-fuchsia-500 to-purple-500",
    halo: "bg-fuchsia-400/20",
    underlineGradient:
      "linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(239,68,102,0.9) 45%, rgba(139,92,246,0.9) 55%, rgba(255,255,255,0) 100%)",
  },
  {
    key: "exseesCloudInfrastructure",
    gradient: "from-cyan-500 via-sky-400 to-emerald-400",
    halo: "bg-cyan-300/20",
    underlineGradient:
      "linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(14,165,233,0.9) 45%, rgba(52,211,153,0.9) 55%, rgba(255,255,255,0) 100%)",
  },
];

const TFLayoutFooterBrands = () => {
  const t = useTranslations("web.components.TFFooter");

  return (
    <div className="my-8 py-8 flex flex-col items-center gap-5 md:gap-6 px-4 text-center">
      <p className="text-xs font-semibold uppercase text-black">
        {t("poweredBy")}
      </p>
      <div className="flex w-full max-w-5xl flex-wrap items-center justify-center gap-8 md:gap-14">
        {brandLogos.map((brand) => (
          <div
            key={brand.key}
            className="relative group px-2 flex flex-col items-center text-center"
          >
            <div
              className={`absolute inset-0 ${brand.halo} blur-3xl opacity-60 group-hover:opacity-90 transition`}
              aria-hidden
            />
            <p
              className={`relative text-xl font-black tracking-tight bg-gradient-to-r bg-clip-text text-transparent ${brand.gradient}`}
            >
              {t(`brands.${brand.key}`)}
            </p>
            <span
              className="absolute inset-x-0 top-full mt-2 h-[2px] opacity-70 group-hover:opacity-100 transition"
              style={{
                backgroundImage: brand.underlineGradient,
                backgroundRepeat: "no-repeat",
                backgroundSize: "100% 100%",
              }}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default TFLayoutFooterBrands;
